"use strict";

var moment = require('moment');

var DATE_FORMAT = 'MMM DD, yyyy';
var DATE_TIME_FORMAT = 'MMM DD, yyyy h:mm A';
var SHORT_DATE_FORMAT = 'MM/DD/yyyy';
var SHORT_DATETIME_FORMAT = 'MM/DD/yyyy h:mm A';
module.exports.DATE_FORMAT = DATE_FORMAT;
module.exports.DATE_TIME_FORMAT = DATE_TIME_FORMAT;
module.exports.SHORT_DATE_FORMAT = SHORT_DATE_FORMAT;
module.exports.SHORT_DATETIME_FORMAT = SHORT_DATETIME_FORMAT;

module.exports.formatDate = function (incomingDate) {
  var showTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var format = arguments.length > 2 ? arguments[2] : undefined;
  var isUTC = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!incomingDate) {
    return null;
  }

  var date = isUTC ? moment.parseZone(incomingDate).utc(true) : moment(incomingDate);

  if (!date.isValid) {
    return incomingDate;
  }

  var defaultFormat = showTime ? DATE_TIME_FORMAT : DATE_FORMAT;
  return date.format(format || defaultFormat);
};

module.exports.formatShortDate = function (incomingDate) {
  return module.exports.formatDate(incomingDate, false, SHORT_DATE_FORMAT, true);
};

module.exports.validateDate = function (date) {
  var year = new Date(date).getFullYear();
  return year && year > 999 && year < 3000;
};

module.exports.maxDate = function () {
  var date = new Date();
  date.setFullYear(date.getFullYear() + 50);
  return date;
};

module.exports.minDate = function () {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 50);
  return date;
};